import { TEMPLATES_SEARCH } from '../../consts/chains';

export const serializeMailTemplateGroups = rawData => {
  const mailTemplateGroups = rawData.mail_template_groups || [];

  return mailTemplateGroups.map(group => ({
    id: group.id,
    value: group.title,
  }));
};

export const serializeMailTemplates = rawData => {
  const mailTemplates = rawData.mail_templates || [];

  return mailTemplates.map(template => ({
    id: template.id,
    value: template.title,
  }));
};

// Подсвечиваем и введённые слова целиком, и основы, по которым бэк нашёл другие формы слов
export const serializeMailTemplatesSearch = (rawData, query = '') => ({
  items: (rawData.mail_templates || []).map(template => ({
    id: template.id,
    title: template.title,
    groupTitle: template.group_title,
    snippet: template.snippet,
  })),
  total: rawData.meta?.total || 0,
  words: [
    ...new Set([
      ...query
        .trim()
        .split(/\s+/)
        .filter(word => word.length >= TEMPLATES_SEARCH.MIN_WORD_LENGTH),
      ...(rawData.meta?.words || []),
    ]),
  ],
});

export const serializeMailTemplate = rawData => ({
  id: rawData.mail_template.id,
  group_id: rawData.mail_template.group_id,
  subject: rawData.mail_template.subject,
  title: rawData.mail_template.title,
  value: rawData.mail_template.body,
  image_url: rawData.mail_template.image_url,
});
